import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { nanoid } from 'nanoid';
import * as React from 'react';
import { Element } from 'slate';
import { RenderElementProps } from 'slate-react';

import { setDefaults } from '../../../../slatePlugins/common/utils/setDefaults';
import { StylingElementProps } from './component/RoundedElement';
import { DEFAULT_ROUNDED, ELEMENT_ROUNDED } from './defaults';
import { RoundedPluginOptions } from './types';

const RoundedElement = dynamicEditorComponent<StylingElementProps>(() =>
  import('./component/RoundedElement').then((mod) => mod.RoundedElement),
{
  loading: ({ props }) => <span {...props?.attributes}>{props?.children}</span>,
},
);

export interface RoundedElementProps extends Element {
  colorKey: string;
  annotationText: string;
  firstDelete: boolean;
}

export const renderRoundedElement =
  (options: RoundedPluginOptions) =>
    ({ element, children, attributes }: RenderElementProps) => {
      if (element.type === ELEMENT_ROUNDED) {
        const {
          roundedElement: { colors },
        } = setDefaults(options, DEFAULT_ROUNDED);
        const { colorKey, annotationText, firstDelete } = element as RoundedElementProps;
        const color = colors.find((i) => i.key === colorKey);
        const id = nanoid();
        return (
        <RoundedElement
          id={id}
          element={element}
          attributes={attributes}
          colors={colors}
          colorKey={colorKey}
          color={color?.color}
          annotatedText={annotationText}
          firstDelete={firstDelete}
        >
          {children}
        </RoundedElement>
        );
      }
      return undefined;
    };
